import React from 'react';
import { Modal, ModalHeader, ModalTitle, ModalContent, ModalFooter } from './Modal';
import { Button } from './Button';
import { API_ENDPOINTS } from '../../config/apiConfig';
import { ImageIcon, DocumentTextIcon, FileIcon } from './Icons';
import { normalizeFileName } from './utils/fileNameEncoding';

const FileListModal = ({ isOpen, onClose, files = [], title = "File Attachments" }) => {
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension);
    const isDocument = ['pdf', 'doc', 'docx', 'txt', 'md'].includes(extension);
    
    if (isImage) {
      return <ImageIcon className="w-6 h-6 text-blue-500" />;
    } else if (isDocument) {
      return <DocumentTextIcon className="w-6 h-6 text-green-500" />;
    } else {
      return <FileIcon className="w-6 h-6 text-gray-500" />;
    }
  };



  // Only log when modal is actually open and has files
  if (isOpen) {
    //console.log('🔍 FileListModal files:', files);
  }

  // Don't render anything if modal is not open
  if (!isOpen) {
    //console.log('📁 FileListModal not rendering - isOpen is false');
    return null;
  }

  //console.log('📁 FileListModal rendering with:', { isOpen, files: files?.length, title });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader>
        <ModalTitle>{title} ({files.length})</ModalTitle>
      </ModalHeader>
      <ModalContent>
        {files.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No files attached
          </div>
        ) : (
          <div className="space-y-3 max-h-96 overflow-y-auto">
            {files.filter(file => !file.isDeleted).map((file, index) => (
              <div key={index} className="flex items-center gap-3 p-3 bg-gray-50 rounded-md">
                {getFileIcon(normalizeFileName(file.fileName || ''))}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{normalizeFileName(file.fileName || '')}</p>
                  <div className="flex items-center gap-2 text-xs text-gray-500">
                    <span>{formatFileSize(file.fileSize)}</span>
                    {file.uploadedAt && (
                      <span>• {new Date(file.uploadedAt).toLocaleDateString()}</span>
                    )}
                  </div>
                </div>
                <a 
                  href={API_ENDPOINTS.fileAttachment.download(file.id)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-blue-600 hover:text-blue-800 underline px-2 py-1 rounded hover:bg-blue-50"
                >
                  Download
                </a>
              </div>
            ))}
          </div>
        )}
      </ModalContent>
      <ModalFooter>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FileListModal;
